import { SetStateAction } from "react";
import StyledButton from "../../buttons/StyledButton";
import styles from "./InputValidationMessages.module.css";

const strings = {
  x: "X",
  close: "Close",
};

type Props = {
  showPopover: boolean;
  hidePopoverOverride: boolean;
  setHidePopoverOverride: React.Dispatch<SetStateAction<boolean>>;
  validationMessages?: string[];
};

export default function InputValidationMessages({
  validationMessages,
  showPopover,
  hidePopoverOverride,
  setHidePopoverOverride,
}: Props) {
  if (
    !validationMessages ||
    validationMessages.length === 0 ||
    (showPopover && hidePopoverOverride)
  ) {
    return null;
  }
  return (
    <div
      className={
        showPopover
          ? styles.validationMessagesPopover
          : styles.validationMessages
      }
    >
      <div className={styles.messageText}>{validationMessages.join("\n")}</div>

      {showPopover && (
        <StyledButton
          className={styles.closePopoverButton}
          variant="transparent"
          onClick={() => setHidePopoverOverride(true)}
          aria-label={strings.close}
        >
          {strings.x}
        </StyledButton>
      )}
    </div>
  );
}
